import { graphql } from "../gql";

export const getSsoDomainIdentityProvidersQueryDoc = graphql(`
  query getSsoDomainIdentityProviders(
    $condition: SsoDomainIdentityProviderCondition
    $first: Int
    $offset: Int
  ) {
    ssoDomainIdentityProviders(
      condition: $condition
      first: $first
      offset: $offset
    ) {
      __typename
      totalCount
      nodes {
        id
        domain
        environment
        tenantId
        config
        isActive
        updatedAt
        __typename
      }
    }
  }
`);
